import { NgModule } from '@angular/core';
import { InstituationComponent } from './list/instituation.component';
import { SharedModule } from '../../shared/shared.module';
import { InstituationRoutingModule } from './instituation.routing';
import { CreateInstituationComponent } from './create/create-instituation.component';

@NgModule({
  declarations: [InstituationComponent, CreateInstituationComponent],
  imports: [SharedModule, InstituationRoutingModule],
})
export class InstituationModule {}
